import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatTime(seconds: number): string {
  if (isNaN(seconds)) return "0:00"

  const minutes = Math.floor(seconds / 60)
  const remainingSeconds = Math.floor(seconds % 60)
  return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`
}

// Helper function to format date
export const formatDate = (dateString: string) => {
  const dt = new Date(dateString)
  return (
    dt.getFullYear() +
    "-" +
    (dt.getMonth() + 1 < 10 ? "0" + (dt.getMonth() + 1) : dt.getMonth() + 1) +
    "-" +
    (dt.getDate() < 10 ? "0" + dt.getDate() : dt.getDate()) +
    " " +
    (dt.getHours() < 10 ? "0" + dt.getHours() : dt.getHours()) +
    ":" +
    (dt.getMinutes() < 10 ? "0" + dt.getMinutes() : dt.getMinutes())
  )
}

// Helper function to format currency
export const formatCurrency = (amount: number, currency: string) => {
  const newAmount = currency === "MNT" ? amount / 100 : amount
  const formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency === "MNT" ? "MNT" : "USD",
    minimumFractionDigits: currency === "MNT" ? 0 : 2,
  })
  return formatter.format(newAmount)
}

export function splitOffset(offset: string) {
  if (!offset || offset.trim() == "") {
    return []
  }

  return offset.trim().split(",").map(Number)
}

// Source: https://stackoverflow.com/a/3410557/10665723
export function getIndicesOf(searchStr: string, str: string, caseSensitive: boolean) {
  const searchStrLen = searchStr.length
  if (searchStrLen == 0) {
    return []
  }
  let startIndex = 0,
    index,
    indices = []
  if (!caseSensitive) {
    str = str.toLowerCase()
    searchStr = searchStr.toLowerCase()
  }
  while ((index = str.indexOf(searchStr, startIndex)) > -1) {
    indices.push(index)
    startIndex = index + searchStrLen
  }
  return indices
}

export function countUnicodeCharacters(text: string) {
  return [...new Intl.Segmenter().segment(text)].length
}

export function formatLineBreaks(text: string) {
  return text.replace(/\n/g, "<br />").replaceAll("&nbsp;", " ")
}

const HTML_ESCAPES: Record<string, string> = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
}

// Titles are user-controlled but rendered with v-html to style pause markers,
// so escape first — the only markup in the output is the span we add.
export function highlightPauses(
  title?: string | null,
  className = "pause-highlight",
) {
  if (!title) return ""
  return title
    .replace(/[&<>"']/g, (c) => HTML_ESCAPES[c]!)
    .replaceAll("...", `<span class="${className}">...</span>`)
}